let map

export function Config () {
  if (!map) map = require(`./config.${process.env.NODE_ENV}.json`)
  return map
}

Config.install = function (vue) {
  vue.prototype.$config = this()
}
